import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';

import { ReactComponent as CopyLinkIcon } from 'assets/copy-white.svg';
import { ReactComponent as DeleteIcon } from 'assets/delete-red.svg';
import { ReactComponent as EditIcon } from 'assets/edit-white.svg';
import CustomButton from 'components/shared/CustomButton/CustomButton';
import CustomDeleteModal from 'components/shared/CustomDeleteModal/CustomDeleteModal';
import { useReducer } from 'react';
import { useNavigate } from 'react-router-dom';
import { modalReducer } from 'reducers/modalReducer';
import { DealsService } from 'service/deals.service';
import { useAppSelector } from 'store/hooks';
import zeplinColor from 'theme/Color';
import InnerInformation from './InnerInformation';

const Header = () => {
  const navigate = useNavigate();
  const deal = useAppSelector((state) => state.deals.deal);

  const {
    dealId,
    name,
    clientName,
    pipelineType,
    stageName,
    closeDate,
    ownerName,
    createdAt,
    dealValue,
  } = deal;
  const formattedCreationDate = createdAt
    ? dayjs(createdAt).format('D MMMM, YYYY [at] HH:MM a')
    : 'N/A';

  const [modalState, dispatch] = useReducer(modalReducer, {
    delete: false,
  });

  const handleCopyLink = async () => {
    await navigator.clipboard.writeText(window.location.href);
  };

  const handleDeleteDeal = async () => {
    try {
      await DealsService.deleteDeal(dealId);
      navigate(-1);
    } catch (error) {}
  };

  return (
    <Box
      sx={{
        bgcolor: zeplinColor.BasicBlack,
        padding: '16px 24px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        {/* Deal Title and date */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Typography sx={{ color: zeplinColor.Neutral1 }} variant='responsiveDisplay5'>
            {name}
          </Typography>
          <Typography sx={{ color: zeplinColor.Neutral1 }} variant='responsiveLabel1'>
            Created on {formattedCreationDate}
          </Typography>
        </Box>

        {/* Deal Actions */}
        <Box
          sx={{
            display: 'flex',
            gap: '12px',
          }}
        >
          <CustomButton
            variant='text'
            text='Copy Link'
            onClick={handleCopyLink}
            disabled={false}
            style={{
              color: zeplinColor.Neutral1,
              ':hover': {
                bgcolor: zeplinColor.Neutral10,
              },
            }}
            icon={<CopyLinkIcon />}
            iconPosition='start'
          />
          <CustomButton
            variant='outlined'
            text='Edit'
            onClick={() => navigate('edit')}
            disabled={false}
            style={{
              borderColor: zeplinColor.Neutral1,
              borderRadius: '8px',
              color: zeplinColor.Neutral1,
              ':hover': {
                bgcolor: zeplinColor.Neutral10,
              },
            }}
            icon={<EditIcon />}
            iconPosition='start'
          />
          <CustomButton
            variant='outlined'
            text='Delete'
            onClick={() => {
              dispatch({ type: 'OPEN', payload: 'delete' });
            }}
            disabled={false}
            style={{
              borderColor: zeplinColor.Error,
              borderRadius: '8px',
              color: zeplinColor.Error,
              ':hover': {
                // bgcolor: `rgba(${'red'}, alpha: 0.5)`, TODO add hover state color
              },
            }}
            icon={<DeleteIcon />}
            iconPosition='start'
          />
        </Box>
      </Box>

      {/* Deal Important basic information */}
      <Box sx={{ bgcolor: zeplinColor.Neutral11 }}>
        <InnerInformation
          data={{ dealId, dealValue, clientName, pipelineType, stageName, closeDate, ownerName }}
        />
      </Box>

      <CustomDeleteModal
        isModalOpen={modalState.delete}
        modalDispatch={dispatch}
        onDelete={handleDeleteDeal}
        title={''}
      />
    </Box>
  );
};

export default Header;
